var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAudit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 7.06204C2.25 6.78499 2.39101 6.52508 2.62843 6.36452L8.47843 2.40838C8.79069 2.19721 9.20931 2.19721 9.52157 2.40838L15.3716 6.36452C15.609 6.52508 15.75 6.78499 15.75 7.06204V14.4662C15.75 15.1752 15.1456 15.75 14.4 15.75H3.6C2.85442 15.75 2.25 15.1752 2.25 14.4662V7.06204Z",
    stroke: "#D7DFE9",
    strokeWidth: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAudit);
export default __webpack_public_path__ + "static/media/IconAudit.e222dc15bf25f408d365c47739d3c718.svg";
export { ForwardRef as ReactComponent };